const CIRCLE_SIZES = {
    large: 200,
    medium: 96,
    small: 56,
    xs: 36,
};
const ICON_SIZES = {
    large: 100,
    medium: 48,
    small: 28,
    xs: 16,
};

export { CIRCLE_SIZES, ICON_SIZES };
